import { useEffect } from 'react';
import { useIdioma } from '../context/IdiomaContext';
import { pareceTextoEnEspanol, traducirTexto } from './catalogo';

const originalesTexto = new WeakMap();
const originalesAtributo = new WeakMap();
const ATRIBUTOS = ['placeholder', 'title', 'aria-label', 'alt'];
const textosPendientes = new Set();

function auditarTraduccion(original, traducido, idioma) {
  if (idioma !== 'en' || !pareceTextoEnEspanol(traducido)) return;
  const clave = original.trim();
  if (!clave || textosPendientes.has(clave)) return;
  textosPendientes.add(clave);
  // Facilita detectar valores nuevos del API sin registrar datos repetidamente.
  console.warn('[i18n] Spanish text still requires an English translation:', clave);
}

function procesarElemento(elemento, idioma) {
  if (!elemento || elemento.nodeType !== Node.ELEMENT_NODE) return;
  let originales = originalesAtributo.get(elemento);
  if (!originales) { originales = {}; originalesAtributo.set(elemento, originales); }
  ATRIBUTOS.forEach((atributo) => {
    if (!elemento.hasAttribute(atributo)) return;
    if (!(atributo in originales)) originales[atributo] = elemento.getAttribute(atributo);
    const valor = idioma === 'es' ? originales[atributo] : traducirTexto(originales[atributo], idioma);
    auditarTraduccion(originales[atributo], valor, idioma);
    if (elemento.getAttribute(atributo) !== valor) elemento.setAttribute(atributo, valor);
  });
}

function procesarArbol(raiz, idioma) {
  if (!raiz) return;
  if (raiz.nodeType === Node.TEXT_NODE) {
    const guardado = originalesTexto.get(raiz);
    if (!guardado || (raiz.nodeValue !== guardado.original && raiz.nodeValue !== guardado.traducido)) {
      originalesTexto.set(raiz, { original: raiz.nodeValue, traducido: traducirTexto(raiz.nodeValue, 'en') });
    }
    const actual = originalesTexto.get(raiz);
    const original = actual.original;
    const valor = idioma === 'es' ? original : traducirTexto(original, idioma);
    auditarTraduccion(original, valor, idioma);
    if (raiz.nodeValue !== valor) raiz.nodeValue = valor;
    return;
  }
  procesarElemento(raiz, idioma);
  Array.from(raiz.childNodes || []).forEach((hijo) => procesarArbol(hijo, idioma));
}

export default function I18nRuntime() {
  const { idioma } = useIdioma();
  useEffect(() => {
    document.documentElement.lang = idioma;
    document.title = idioma === 'en' ? 'Claims and Authorizations' : 'Reclamos y Autorizaciones';
    procesarArbol(document.body, idioma);
    const observer = new MutationObserver((mutaciones) => {
      mutaciones.forEach((m) => {
        if (m.type === 'characterData') procesarArbol(m.target, idioma);
        else {
          m.addedNodes.forEach((nodo) => procesarArbol(nodo, idioma));
          if (m.type === 'attributes') procesarElemento(m.target, idioma);
        }
      });
    });
    observer.observe(document.body, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ATRIBUTOS });
    return () => observer.disconnect();
  }, [idioma]);
  return null;
}
